export const dashboardConfig = {
  subtitle: "Data that helps you make a difference", // Change this text as needed
};